import React, {useEffect, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";
import classnames from "classnames";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import useEnterEffect from "../../hooks/useEnterEffect";
import Button from "@mui/material/Button";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";


const initialState = {
    id: null,
    name: 'Registration Fee',
    state: '',
    amount: null,
    is_capped: false,
    is_taxed: true,
    is_tax_capped: false,
}

export const DefaultSettingsCreateRegFee = ({ usState }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { quoteSettings, setSettingsStateWithUpdate } = useDefaultQuoteSettingsContext()
    const getInitialState = (usState) =>  {
        return ({
            ...initialState,
            state: usState
        })
    }
    const [feeState, setFeeState] = useState(getInitialState(usState))

    const hasRegFee = () => {
        return Boolean(
            feeState &&
            feeState?.state?.length &&
            feeState?.amount !== null
        )
    }

    const setNewRegInSettings = () => {
        if (hasRegFee()) {
            setSettingsStateWithUpdate({
                fees: [...quoteSettings.fees, feeState]
            }, true)
        }
    }

    useEnterEffect(function updateQuoteSettingsStateOnEnter(){
        setNewRegInSettings()
    }, [feeState])

    useEffect(function updateStateWhenUsStateChanges() {
        setFeeState({...feeState, state: usState})
    }, [usState]);


    return (
        <TableRow
            key={'Acq Fee'}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
                background: 'var(--primary-50)'
            }}
            className={'default-settings-fee'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <span>Registration Fee</span>
                    <Button
                        style={{
                            alignSelf: 'end'
                        }}
                        disabled={!hasRegFee()}
                        onClick={setNewRegInSettings}
                    >
                        Add <KeyboardReturnIcon/>
                    </Button>
                </div>

            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        className={'DealPageFee'}
                        align="right"
                        size={'small'}
                        width={'20%'}
                    >
                    </TableCell>
                    <TableCell
                        className={'DealPageFee'}
                        align="right"
                        size={'small'}
                        width={'20%'}
                    >
                        <Switch
                            checked={feeState.is_capped}
                            onChange={() => {
                                setFeeState({...feeState, is_capped: !feeState.is_capped})
                            }}
                        />
                    </TableCell>
                </React.Fragment>
            }
            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'60%'}
            >
                <CustomCurrencyInput
                    onChange={(value) => setFeeState({...feeState, amount: value})}
                    className={classnames('payment-row_value custom-fee-input', {
                        loading: false
                    })}
                    prefix="$"
                    value={feeState.amount}
                    allowNull={false}
                    InputProps={isTabletOrMobile ? {} : undefined}
                />
            </TableCell>
        </TableRow>
    )
}